import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";

const PeriodicReport = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const [searchTerm, setSearchTerm] = useState("");
  const [periodicReport, setPeriodicReport] = useState([]);
  const [hrNameList, setHRNameList] = useState([]);
  const [filterFormData, setFilterData] = useState([
    { label: "HR Name", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);

  const columns = {
    HRName: { text: "HR Name", visible: true },
    SelectedForNextRound: { text: "Selected For Next Round", align: "center", visible: true },
    FinalSelected: { text: "Final Selected", align: "center", visible: true },
    Rejected: { text: "Rejected", align: "center", visible: true },
  };
  const defaultColumns = {
    HRName: true,
    SelectedForNextRound: true,
    FinalSelected: true,
    Rejected: true,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Periodic Report"))
  }, [])
  const formDatas = [
    { name: "HR Name", type: "Select", options: [...hrNameList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];
  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };


  const [apiStatus, SetApiStatus] = useState(undefined)

  const fetchPeriodicReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/8?P_CreatedBy=&P_FromDate=${lastMonthDate}&P_ToDate=${todayDate}`
      );
      if (response?.status === 200) {
        const data = response?.data?.data?.periodic_data;
        setPeriodicReport(data);

        // Hr Name List
        const hrList = response?.data?.data?.hrNames.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);
        SetApiStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    fetchPeriodicReport();
  }, []);

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/8?P_CreatedBy=${filterFormData.find((o) => o.label === "HR Name")
          ? filterFormData.find((o) => o.label === "HR Name").value
          : ""
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }`
      );
      if (response?.status === 200) {
        const data = response?.data?.data?.periodic_data;
        setPeriodicReport(data);

        // Hr Name List
        const hrList = response?.data?.data?.hrNames.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);
        SetApiStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };



  const handleReset = () => {
    fetchPeriodicReport()
    setFilterData([
      { label: "HR Name", value: "" },
      { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    ])
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={periodicReport}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              handleReset={handleReset}
              isFilterRequired={true}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              isSorting={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>

    </>
  );
};

export default PeriodicReport;
